import React from 'react';
import Loading from '@/components/Loading';
export default function PageLoading() {
    return (React.createElement("div", { style: { height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        React.createElement(Loading, null)));
}
